import { filter, forEach, isNil } from 'ramda';
import { commitMutation,
  graphql } from 'react-relay';
import environment from '../.';
import { basicMutationOnCompleted, onErrorMutation } from './common/common';

const mutation = graphql`
mutation RemoveUserMutation($userId: ID!) {
  removeUser(userId: $userId) {
    ok
    error
  }
}
`;

export default ({ userId }, done) => {
  const variables = { userId };

  commitMutation(
    environment(),
    {
      mutation,
      variables,
      updater: (proxyStore, { removeUser: { ok } }) => {
        if (ok) {
          const teams = proxyStore.getRoot().getLinkedRecords('teams');

          if (!isNil(teams)) {
            forEach(team => {
              const linkedMembers = team.getLinkedRecords('members');

              if (!isNil(linkedMembers)) {
                const members = filter(member => {
                  const user = member.getLinkedRecord('user');
                  const id = user.getValue('id');

                  return id !== userId;
                })(linkedMembers);

                team.setLinkedRecords(members, 'members');
              }
            });
          }
        }
      },
      onCompleted: ({ removeUser }) => basicMutationOnCompleted(removeUser, done),
      onError: error => onErrorMutation(error, done)
    }
  );
};
